import api from 'services/api.service';

const resource = '/oath2';

export const getGmailAuthUrl = (redirectToAfterGmailAdded, userId, companyId, gmailAddress) => api
  .get(`${resource}/get-gmail-auth-url`, { redirectToAfterGmailAdded, userId, companyId, gmailAddress });

export const getGmailIntegrations = (companyId) => api
  .get(`${resource}/get-gmail-integrations`, { companyId });

export const setGmailAsDefault = (gmailAddress, companyId) => api
  .post(`${resource}/set-gmail-as-default`, { gmailAddress, companyId });

export const deleteGmailIntegration = (gmailAddress, companyId) => api
  .post(`${resource}/delete-gmail-integration`, { gmailAddress, companyId });
